import { render, staticRenderFns } from "./quoterManage.vue?vue&type=template&id=238d0f5a&scoped=true&"
import script from "./quoterManage.vue?vue&type=script&lang=js&"
export * from "./quoterManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d0f5a",
  null
  
)

export default component.exports